import { SharingData } from '../../schema/SharingData';
import isBefore from 'owa-datetime/lib/owaDate/isBefore';
import now from 'owa-datetime/lib/userDate/now';

export function isExpired(sharingData: SharingData): boolean {
    return (
        sharingData &&
        sharingData.sharingInfo &&
        !!sharingData.sharingInfo.expirationDate &&
        isBefore(sharingData.sharingInfo.expirationDate, now())
    );
}
